import { createContext, FC, useContext } from 'react';
import { ChatReceiver, ChatRecord } from '../../chat/chat-types';
import { useChat } from '../../chat/hooks/useChat';
import ZoomContext from '../../../context/zoom-context';
import { ChatPrivilege } from '@zoom/videosdk';

export type ChatContextProps = {
  records: ChatRecord[];
  receivers: ChatReceiver[];
  privilege: ChatPrivilege;
  chatUser: ChatReceiver | null;
  isHostOrManager: boolean;
  setChatUserId: (userId: number) => void;
  sendMessage: (text: string) => void;
  sendFile: (file: File) => Promise<void>;
  resendFile: (retryToken: string, fileUuid: string) => Promise<void>;
  downloadFile: (id: string, blob?: boolean) => Promise<void>;
};
export const ChatContext = createContext<ChatContextProps>(null as any);

type Props = {
  children: React.ReactNode;
};
const ChatProvider: FC<Props> = ({ children }) => {
  const zmClient = useContext(ZoomContext);
  const chatClient = zmClient.getChatClient();
  const {
    records,
    receivers,
    privilege,
    chatUser,
    isHostOrManager,
    setChatUserId,
    sendMessage,
    sendFile,
    resendFile,
    downloadFile
  } = useChat(zmClient, chatClient);
  return (
    <ChatContext.Provider
      value={{
        records,
        receivers,
        privilege,
        chatUser,
        isHostOrManager,
        setChatUserId,
        sendMessage,
        sendFile,
        resendFile,
        downloadFile
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export default ChatProvider;
